import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Service.css"
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../firebase";
import img1 from "../../assets/images/AC-service-carousel-main.avif";
import img2 from "../../assets/images/carpenter-carousel-main.avif";
import img3 from "../../assets/images/electrician-carousel-main.avif";
import img4 from "../../assets/images/fridge-repair-carousel-main.avif";
import img5 from "../../assets/images/plumber-carousel-main.avif";
import img6 from "../../assets/images/washing-machine-carousel-main.avif";
import img15 from "../../assets/images/AC2.jpeg"
import img16 from "../../assets/images/carpenter2.jpeg"
import img17 from "../../assets/images/Elect1.jpg"
import img18 from "../../assets/images/fridge2.webp"
import img19 from "../../assets/images/plumber2.jpg"
import img20 from "../../assets/images/Washing2.jpeg"
import img7 from "../../assets/images/why-choose-us.png";
import img8 from "../../assets/images/cost.png";
import img9 from "../../assets/images/customer.png";
import img10 from "../../assets/images/quality.png";
import img11 from "../../assets/images/time.png";
import img12 from "../../assets/images/trust.png";
import img13 from "../../assets/images/warranty.png";
import img14 from "../../assets/images/All-in-one.png";
import img21 from "../../assets/images/CCTV1.jpg";
import img22 from "../../assets/images/CCTV2.jpg";
import img23 from "../../assets/images/cooler-1.png";
import img24 from "../../assets/images/coolers-2.jpg";
import img25 from "../../assets/images/Laundry/laundry.jpg";
import img26 from "../../assets/images/Laundry/laundry1.jpg";
const Service = () => {
  const sectionRef = useRef(null);
  const [startCount, setStartCount] = useState(false);

  const [stats, setStats] = useState({
  happyCustomers: 500,
  servicesCompleted: 500,
});

const counters = [
  {
    id: 1,
    label: "Happy Customers Served",
    target: stats.happyCustomers,
  },
  {
    id: 2,
    label: "Successful Services Completed",
    target: stats.servicesCompleted,
  },
  {
    id: 3,
    label: "Certified Expert Technicians",
    target: 50,
  },
  {
    id: 4,
    label: "Service Categories Available",
    target: 100,
  },
];

const [counts, setCounts] = useState(counters.map(() => 0));

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setStartCount(true);
        }
      },
      { threshold: 0.4 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);
  useEffect(() => {
  const fetchStats = async () => {
    try {
      const docRef = doc(db, "stats", "dashboard");
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        setStats(docSnap.data());
      }
    } catch (error) {
      console.log(error);
    }
  };

  fetchStats();
}, []);
  useEffect(() => {
  if (!startCount) return;

  counters.forEach((counter, index) => {
    let start = 0;

    const incrementValue = counter.target / 100;

    const interval = setInterval(() => {
      start += incrementValue;

      if (start >= counter.target) {
        start = counter.target;
        clearInterval(interval);
      }

      setCounts((prev) => {
        const updated = [...prev];
        updated[index] = Math.floor(start);
        return updated;
      });
    }, 20);
  });
}, [startCount, stats]);
  const navigate = useNavigate();
  useEffect(() => {
    if (window.$) {
      window.$(".owl-carousel").owlCarousel({
        items: 3,
        loop: true,
        margin: 10,
        autoplay: true,
        autoplayTimeout: 2000,
        autoplayHoverPause: true,
        responsive: {
          0: { items: 1 },
          768: { items: 2 },
          1024: { items: 4 }
        }
      });
    }
  }, []);
  return (
    <div className="container-fluid service">
      
      <div className="service-section text-center py-5" id="service-about">
        <div className="container my-5">
          <p className="service-subtitle">HOME MAINTENANCE SOLUTIONS</p>
          <h2 className="service-title text-description type-me">Our Services</h2>
          <div className="container py-5">
            <div className="row g-4 justify-content-center">

              {/* Row 1 */}
              <div className="col-12 col-md-4 text-center">
               <div className="hover-card" onClick={() => navigate("/laundry")}>
                  <img src={img25} className="default-img img-fluid" alt="" />
                  <img src={img26} className="hover-img img-fluid" alt="" />
                  <p>Laundry</p>
                </div> 
              </div>

              <div className="col-12 col-md-4 text-center">
                <div className="hover-card" onClick={() => navigate("/acmachine")}>
                  <img src={img15} className="default-img img-fluid" alt="" />
                  <img src={img1} className="hover-img img-fluid" alt="" />
                  <p>AC Machine</p>
                </div>
              </div>

              <div className="col-12 col-md-4 text-center">
                <div className="hover-card" onClick={() => navigate("/carpenter")}>
                  <img src={img2} className="default-img img-fluid" alt="" />
                  <img src={img16} className="hover-img img-fluid" alt="" />
                  <p>Carpenter</p>
                </div>
              </div>

              {/* Row 2 */}
              <div className="col-12 col-md-4 text-center">
                <div className="hover-card" onClick={() => navigate("/electrician")}>
                  <img src={img3} className="default-img img-fluid" alt="" />
                  <img src={img17} className="hover-img img-fluid" alt="" />
                  <p>Electrician</p>
                </div>
              </div>

              <div className="col-12 col-md-4 text-center">
                <div className="hover-card" onClick={() => navigate("/fridge")}>
                  <img src={img4} className="default-img img-fluid" alt="" />
                  <img src={img18} className="hover-img img-fluid" alt="" />
                  <p>Fridge Repair</p>
                </div>
              </div>

              <div className="col-12 col-md-4 text-center">
                <div className="hover-card" onClick={() => navigate("/plumber")}>
                  <img src={img5} className="default-img img-fluid" alt="" />
                  <img src={img19} className="hover-img img-fluid" alt="" />
                  <p>Plumber</p>
                </div>
              </div>

              {/* Row 3 */}
              <div className="col-12 col-md-4 text-center">
                <div className="hover-card" onClick={() => navigate("/washing")}>
                  <img src={img20} className="default-img img-fluid" alt="" />
                  <img src={img6} className="hover-img img-fluid" alt="" />
                  <p>Washing Machine</p>
                </div>
              </div>

              <div className="col-12 col-md-4 text-center">
                <div className="hover-card" onClick={() => navigate("/cooler")}>
                  <img src={img23} className="default-img img-fluid" alt="" />
                  <img src={img24} className="hover-img img-fluid" alt="" />
                  <p>Cooler service</p>
                </div>
              </div>

              <div className="col-md-4 text-center">
                <div className="hover-card" onClick={() => navigate("/cctv")}>
                  <img src={img21} className="default-img img-fluid" alt="" />
                  <img src={img22} className="hover-img img-fluid" alt="" />
                  <p>CCTV Technician</p>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <div className="counter-section" ref={sectionRef}>
        <div className="counter-container">
          {counters.map((counter, index) => (
            <div key={counter.id} className="counter-box">
              <h2>{counts[index]}+</h2>
              <p>{counter.label}</p>
            </div>
          ))}
        </div>
      </div>
      <div className="service-section text-center py-5">
        <div className="container my-5">
          <p className="service-subtitle"> Smart Solutions For Modern Homes</p>
          <h2 className="service-title">All-in-One Home Services</h2>
        </div>
      </div>
      <div className="owl-carousel owl-theme">
        <div className="item">
          <div className="service-card">
            <span className="status-badge">Within 1 Day</span>
            <div className="service-img">
              <img src={img1} alt="AC Service" />
              <span className="service-tag">AC Service</span>
            </div>
            <div className="service-body">
              <h4>AC Installation & Repair</h4>
              <p>✔ Gas Filling</p>
              <p>✔ Cooling Issue Fix</p>
              <p>✔ Installation Support</p>
              <p>✔ Installation Support</p>
              <div className="service-footer">
                <span className="price">Starting at ₹99</span>
                <button className="book-btn" onClick={() => navigate("/acmachine")}>
                  Book Now
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="item">
          <div className="service-card">
            <span className="status-badge">Within 1 Day</span>
            <div className="service-img">
              <img src={img2} alt="Carpenter" />
              <span className="service-tag">Carpenter</span>
            </div>

            <div className="service-body">
              <h4>Furniture Repair</h4>
              <p>✔ Door & Window Fix</p>
              <p>✔ Wood Polishing</p>
              <p>✔ Custom Work</p>
              <p>✔ Installation Support</p>
              <div className="service-footer">
                <span className="price">Starting at ₹99</span>
                <button className="book-btn" onClick={() => navigate("/carpenter")}>Book Now</button>
              </div>
            </div>
          </div>
        </div>
        <div className="item">
          <div className="service-card">
            <span className="status-badge">Within 1 Day</span>
            <div className="service-img">
              <img src={img3} alt="Electrician" />
              <span className="service-tag">Electrician</span>
            </div>
            <div className="service-body">
              <h4>Electrical Repairs </h4>
              <p>✔ Switch & Socket Repair</p>
              <p>✔ Wiring Installation</p>
              <p>✔ Fan & Light Fixing</p>
              <p>✔ MCB & Fuse Repair</p>
              <div className="service-footer">
                <span className="price">Starting at ₹99</span>
                <button className="book-btn" onClick={() => navigate("/electrician")}>
                  Book Now
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="item">
          <div className="service-card">
            <span className="status-badge">Within 1 Day</span>
            <div className="service-img">
              <img src={img4} alt="Fridge Repair" />
              <span className="service-tag">Fridge Repair</span>
            </div>
            <div className="service-body">
              <h4>Home Refrigerator Repair Solutions</h4>
              <p>✔ Cooling Issue Fix</p>
              <p>✔ Gas Refill</p>
              <p>✔ Compressor Repair</p>
              {/* <p>✔ Deep Freezer service</p> */}
              <div className="service-footer">
                <span className="price">Starting at ₹99</span>
                <button className="book-btn" onClick={() => navigate("/fridge")}>
                  Book Now
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="item">
          <div className="service-card">
            <span className="status-badge">Within 1 Day</span>
            <div className="service-img">
              <img src={img5} alt="Plumber" />
              <span className="service-tag">Plumber</span>
            </div>
            <div className="service-body">
              <h4>Plumbing Repair and Installation</h4>
              <p>✔ Tap & Pipe Repair</p>
              <p>✔ Leakage Fix</p>
              <p>✔ Bathroom Fittings</p>
              {/* <p>✔ Drain Block Removal</p> */}
              <div className="service-footer">
                <span className="price">Starting at ₹99</span>
                <button className="book-btn" onClick={() => navigate("/plumber")}>
                  Book Now
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="item">
          <div className="service-card">
            <span className="status-badge">Within 1 Day</span>
            <div className="service-img">
              <img src={img6} alt="Washing Machine" />
              <span className="service-tag">Washing Machine</span>
            </div>
            <div className="service-body">
              <h4>Washing Machine Repair & Service</h4>
              <p>✔ Drum & Motor Repair</p>
              <p>✔ Water Leakage Fix</p>
              <p>✔ Installation Support</p>
              {/* <p>✔ Noise & Vibration Repair</p> */}
              <div className="service-footer">
                <span className="price">Starting at ₹99</span>
                <button className="book-btn" onClick={() => navigate("/washing")}>
                  Book Now
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="item">
          <div className="service-card">
            <span className="status-badge">Within 1 Day</span>
            <div className="service-img">
              <img src={img21} alt="CCTV" />
              <span className="service-tag">CCTV technician</span>
            </div>
            <div className="service-body">
              <h4>CCTV Technician Service</h4>
              <p>✔ CCTV Camera Installation</p>
              <p>✔ DVR/NVR Setup & Configuration</p>
              <p>✔ Camera Repair & Maintenance</p>
              <p>✔ Camera Troubleshooting</p>
              <div className="service-footer">
                <span className="price">Starting at ₹99</span>
                <button className="book-btn" onClick={() => navigate("/cctv")}>
                  Book Now
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="item">
          <div className="service-card">
            <span className="status-badge">Within 1 Day</span>
            <div className="service-img">
              <img src={img3} alt="Electrician" />
              <span className="service-tag">Cooler Service</span>
            </div>
            <div className="service-body">
              <h4>Cooler Services</h4>
              <p>✔ Air Cooler Installation</p>
              <p>✔ Cooling Problem Repair</p>
              <p>✔ Motor & Pump Replacement</p>
              <p>✔ Full Cooler Cleaning & Service</p>
              <div className="service-footer">
                <span className="price">Starting at ₹99</span>
                <button className="book-btn" onClick={() => navigate("/cooler")}>
                  Book Now
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="service-section text-center py-5">
        <div className="container my-5">
          <p className="service-subtitle">CUSTOMER FIRST APPROACH</p>
          <h2 className="service-title">Why Choose Us?</h2>
        </div>
      </div>
      <div className="container why-section ">
        <div className="row align-items-center">
          <div className="col-12 col-md-3 why-left">
            <div className="why-box">
              <img src={img10} />
              <span className="heading-span">High Quality <br /> <span className="text-secondary content-span">Excellence with strict standards.</span></span>
            </div>

            <div className="why-box">
              <img src={img13} />
              <span className="heading-span">Recommended Warranty Period<br /> <span className="text-secondary content-span">Extended reliable warranty coverage.</span></span>
            </div>

            <div className="why-box">
              <img src={img9} />
              <span className="heading-span">Customer Satisfaction<br /><span className="text-secondary content-span">Delivering happiness through excellent service.</span></span>
            </div>
          </div>
          <div className="col-12 col-md-6 text-center center-img">
            <img src={img7} className="why-choose-us img-fluid" alt="Why Choose Us" />
          </div>
          <div className="col-12 col-md-3 why-right">
            <div className="why-box">
              <img src={img11} />
              <span className="heading-span">Timely Management <br /> <span className="text-secondary content-span">On-time service with efficient coordination.</span></span>
            </div>

            <div className="why-box">
              <img src={img8} />
              <span className="heading-span">Reasonable Cost Price<br /><span className="text-secondary content-span">Affordable pricing without compromising quality</span></span>
            </div>

            <div className="why-box">
              <img src={img12} />
              <span className="heading-span">Trust Worthy<br /><span className="text-secondary content-span">Reliable service you can confidently trust.</span></span>
            </div>
          </div>

        </div>
      </div>
      <div className="service-section text-center py-5">
        <div className="container my-5">
          <p className="service-subtitle">CUSTOMER SUPPORT & HELP</p>
          <h2 className="service-title">Frequently Asked Questions</h2>
        </div>
      </div>
      <div className="container my-5">
        <div className="row">
          <div className=" col-12 accordion-card col-md-6">
            <div className="accordion" id="accordion1">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button className="accordion-button" data-bs-toggle="collapse" data-bs-target="#collapseOne">How quickly can I book a service?</button>
                </h2>
                <div id="collapseOne" class="accordion-collapse collapse show" data-bs-parent="#accordion1">
                  <div class="accordion-body">
                    <p>You can book instantly through our website, and our technician will contact you shortly to confirm the visit.</p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button className="accordion-button" data-bs-toggle="collapse" data-bs-target="#collapsetwo">Do you provide same-day service?</button>
                </h2>
                <div id="collapsetwo" class="accordion-collapse collapse " data-bs-parent="#accordion1">
                  <div class="accordion-body">
                    <p>Yes, we offer same-day service based on availability in your area</p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button className="accordion-button" data-bs-toggle="collapse" data-bs-target="#collapsethree">Is there any service warranty?</button>
                </h2>
                <div id="collapsethree" class="accordion-collapse collapse " data-bs-parent="#accordion1">
                  <div class="accordion-body">
                    <p>Yes, we provide a recommended warranty period depending on the type of service performed.</p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button className="accordion-button" data-bs-toggle="collapse" data-bs-target="#collapsefour">Are your technicians verified?</button>
                </h2>
                <div id="collapsefour" class="accordion-collapse collapse " data-bs-parent="#accordion1">
                  <div class="accordion-body">
                    <p>Absolutely. All our technicians are trained, experienced, and background-verified.</p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button className="accordion-button" data-bs-toggle="collapse" data-bs-target="#collapsefive">How much will the service cost?</button>
                </h2>
                <div id="collapsefive" class="accordion-collapse collapse " data-bs-parent="#accordion1">
                  <div class="accordion-body">
                    <p>Service cost depends on the issue. We provide transparent pricing with no hidden charges.</p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button className="accordion-button" data-bs-toggle="collapse" data-bs-target="#collapsesix">Do you provide services for all brands?</button>
                </h2>
                <div id="collapsesix" class="accordion-collapse collapse " data-bs-parent="#accordion1">
                  <div class="accordion-body">
                    <p>Yes, we repair and service all major brands of ACs, refrigerators, and washing machines.</p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button className="accordion-button" data-bs-toggle="collapse" data-bs-target="#collapseseven">What payment methods do you accept?</button>
                </h2>
                <div id="collapseseven" class="accordion-collapse collapse " data-bs-parent="#accordion1">
                  <div class="accordion-body">
                    <p>We accept cash, UPI, and other digital payment options.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6 faq-img">
            <img src={img14} className="w-100 h-100" />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Service
